import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import {
  SubmitModalStepper,
  SubmitModalDialogContent,
  SubmitModalDialogContentInner,
  SubmitModalDialogActions,
  MainContent,
  Transition
} from '../SubmitModelDialog/common'
import DialogTitle from '../SubmitModelDialog/DialogTitle'
import FinishedView from '../SubmitModelDialog/FinishedView'
import InputDetailsView from '../SubmitModelDialog/InputDetailsView'
import { TagModelView, TagDiseaseView, TagRdocView } from '../SubmitModelDialog/TagView'
import { useEditModelDialog } from './hooks'

const steps = ['Model', 'Disease', 'RDoC Constract', 'Details']
const backButtons = ['Cancel', 'Back', 'Back', 'Back', '']

const Component = () => {
  const { paper, dialog, handle } = useEditModelDialog()
  const { open, isOwner, activeStep, isReadySubmit } = dialog
  const { handleClose, handleBack, handleNext, handleSubmit, handleDetailsChange, handleIsReadySubmit } = handle

  const nextButtons = ['Next', 'Next', 'Next', isOwner ? 'Edit' : 'Edit Request', '']

  const StepView = React.useCallback(() => {
    switch (activeStep) {
      case 0:
        return <TagModelView paper={paper} handleNext={handleNext} handleDetailsChange={handleDetailsChange} isEdit />
      case 1:
        return <TagDiseaseView paper={paper} handleNext={handleNext} handleDetailsChange={handleDetailsChange} />
      case 2:
        return (
          <TagRdocView
            paper={paper}
            handleNext={handleNext}
            handleDetailsChange={handleDetailsChange}
            // NOTE: このViewを抜けるときにisRedySubmitをfalseにするようにする
            handleIsReadySubmit={handleIsReadySubmit}
          />
        )
      case 3:
        return null // 暫定対処：View側へ移動する
      // return <InputDetailsView type={isOwner ? 'edit' : 'editRequest'} paper={paper} handleNext={handleNext} handleBack={handleBack} handleDetailsChange={handleDetailsChange} handleIsReadySubmit={handleIsReadySubmit} />
      case 4:
        return isReadySubmit ? <FinishedView handleSubmit={handleSubmit} /> : <></>
      default:
        return <></>
    }
  }, [activeStep, handleDetailsChange, handleIsReadySubmit, handleNext, handleSubmit, isReadySubmit, paper])

  const dialogContentRef = React.useRef<HTMLDivElement>(null)
  React.useEffect(() => {
    // タブ遷移ごとにスクロールを先頭に初期化する
    try {
      dialogContentRef.current?.scrollTo(0, 0)
    } catch (error) {
      console.error('scroll can not work in your browser')
    }
  }, [activeStep])

  return (
    <Dialog
      fullScreen
      TransitionComponent={Transition}
      onClose={handleClose}
      // aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        {isOwner ? 'Edit' : 'Edit Request'}
      </DialogTitle>
      <SubmitModalDialogContent dividers ref={dialogContentRef}>
        <SubmitModalDialogContentInner>
          <SubmitModalStepper activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step key={label} completed={index < activeStep}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </SubmitModalStepper>
          <MainContent>
            <StepView />
            {/* 暫定対処：View側へ移動する */}
            {activeStep === 3 && (
              <InputDetailsView
                type={isOwner ? 'edit' : 'editRequest'}
                paper={paper}
                handleNext={handleNext}
                handleBack={handleBack}
                handleDetailsChange={handleDetailsChange}
                handleIsReadySubmit={handleIsReadySubmit}
              />
            )}
          </MainContent>
        </SubmitModalDialogContentInner>
      </SubmitModalDialogContent>
      <SubmitModalDialogActions>
        <Button onClick={handleBack} color="primary">
          {backButtons[activeStep]}
        </Button>
        {nextButtons[activeStep] !== '' && (
          <Button
            onClick={() => {
              if (activeStep === 3) {
                handleIsReadySubmit(true)
              }
              setTimeout(() => {
                handleNext() // 時間差でready系のstateが発動してからnextに移動する
              }, 100)
            }}
            color="primary"
          >
            {nextButtons[activeStep]}
          </Button>
        )}
      </SubmitModalDialogActions>
    </Dialog>
  )
}

export default Component
